<div [attr.id]="key" [ngClass]="class" class="chart-area chart_height_xxs" width="100%" [style.height]="height+ 'px'">
</div>